import { render, staticRenderFns } from "./IconReject.vue?vue&type=template&id=2156e33a&scoped=true"
import script from "./IconReject.vue?vue&type=script&lang=js"
export * from "./IconReject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2156e33a",
  null
  
)

export default component.exports